const amount = (value, optional = false) => {
  if (value === null || value === undefined || (typeof value === 'string' && !value.trim())) return optional ? 0 : null;
  if (!['number', 'string'].includes(typeof value)) return null;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : null;
};
const finite = result => Object.values(result).every(value => Number.isFinite(value)) ? result : null;

export function calculateHourlyRate(input) {
  const income = amount(input.income);
  const hours = amount(input.hours);
  const weeks = amount(input.weeks);
  const expenses = amount(input.expenses, true);
  const margin = amount(input.margin, true);
  if ([income, hours, weeks, expenses, margin].includes(null) || hours <= 0 || hours > 168 || weeks <= 0 || weeks > 52 || margin > 99.99) return null;
  const annualExpenses = expenses * 12;
  const base = income + annualExpenses;
  const yearlyHours = hours * weeks;
  const needed = base / (1 - margin / 100);
  const hourly = needed / yearlyHours;
  return finite({ income, hours, weeks, expenses, margin, annualExpenses, base, yearlyHours, needed, baseRate: base / yearlyHours, hourly, daily: hourly * 8 });
}

export function calculateRetainer(input) {
  const hours = amount(input.hours);
  const rate = amount(input.rate);
  const overhead = amount(input.overhead, true);
  const margin = amount(input.margin, true);
  if ([hours, rate, overhead, margin].includes(null) || hours <= 0 || margin > 99.99) return null;
  const base = hours * rate;
  const overheadAmount = base * overhead / 100;
  const loadedCost = base + overheadAmount;
  const monthly = loadedCost / (1 - margin / 100);
  return finite({ hours, rate, overhead, margin, base, overheadAmount, loadedCost, monthly, marginAmount: monthly - loadedCost, annual: monthly * 12, effectiveHourly: monthly / hours });
}

export const planningMoney = value => typeof value === 'number' && Number.isFinite(value)
  ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value) : '—';
export const planningNumber = value => typeof value === 'number' && Number.isFinite(value)
  ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value) : '—';
export const planningPercent = value => typeof value === 'number' && Number.isFinite(value) ? `${planningNumber(value)}%` : '—';
